export class PriceLevelModel {
    id: number;
    name: string;
    discountFee: number;
    baseCatalogId: number;
}
